/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_No_ContentInputs */

const en_player_no_content = /** @type {(inputs: Player_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course content not found.`)
};

const ja_player_no_content = /** @type {(inputs: Player_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースコンテンツが見つかりません。`)
};

const fr_player_no_content = /** @type {(inputs: Player_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu du cours non trouvé.`)
};

const de_player_no_content = /** @type {(inputs: Player_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursinhalt nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Course content not found." |
*
* @param {Player_No_ContentInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_no_content = /** @type {((inputs?: Player_No_ContentInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_No_ContentInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_no_content(inputs)
	if (locale === "ja") return ja_player_no_content(inputs)
	if (locale === "fr") return fr_player_no_content(inputs)
	return de_player_no_content(inputs)
});